import React from 'react';
import PropTypes from 'prop-types';
import humanize from 'humanize-plus';
import { kebabCase } from 'lodash';
const JobsRow = props => {
  const _props$data = props.data,
    id = _props$data.id,
    formID = _props$data.formID,
    jobNumber = _props$data.jobNumber,
    name = _props$data.name,
    index = props.index,
    onClick = props.onClick;
  const handleClick = () => onClick(id, formID);
  return /*#__PURE__*/React.createElement("tr", {
    onClick: handleClick,
    className: "t-jr-".concat(index)
  }, /*#__PURE__*/React.createElement("td", {
    className: "t-jr-job-number t-jr-job-number-".concat(kebabCase(jobNumber))
  }, jobNumber), /*#__PURE__*/React.createElement("td", null, name ? humanize.truncate(name, 50) : undefined));
};
JobsRow.propTypes = {
  index: PropTypes.number.isRequired,
  data: PropTypes.shape({
    formID: PropTypes.string,
    id: PropTypes.string.isRequired,
    jobNumber: PropTypes.string,
    name: PropTypes.string
  }).isRequired,
  onClick: PropTypes.func.isRequired
};
export default JobsRow;